import { UserShortWithWork } from "tm-shared/types";

import { useLoadUserSchedule } from "@/pages/SV/Team/hooks/useLoadUserSchedule";

import { StyledNoResults, StyledSectionTitle } from "../../Styled";
import { MemberCard } from "../MemberCard";

interface TeamListProps {
    members: UserShortWithWork[];
    teamRoutes: { [userId: string]: string };
    searchQuery: string;
    isProcessing: boolean;
    onLoadSchedule: ReturnType<
        typeof useLoadUserSchedule
    >["handleLoadUserSchedule"];
    onNavigate: () => void;
}

export const TeamList = ({
    members,
    teamRoutes,
    searchQuery,
    isProcessing,
    onLoadSchedule,
    onNavigate,
}: TeamListProps) => {
    return (
        <>
            <StyledSectionTitle>Команда ({members.length})</StyledSectionTitle>

            {members.length === 0 && searchQuery && (
                <StyledNoResults>
                    Нічого не знайдено за запитом &quot;{searchQuery}&quot;
                </StyledNoResults>
            )}

            {members.map((member) => (
                <MemberCard
                    key={member.id}
                    member={member}
                    routeId={teamRoutes[member.userId ?? ""]}
                    isActive={false}
                    isProcessing={isProcessing}
                    onLoadSchedule={onLoadSchedule}
                    onNavigate={onNavigate}
                />
            ))}
        </>
    );
};
